import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { CategoryLinks, CategoryLinksItem } from '@grandvisionhq/content';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

// We need to stop this event from bubbling up in order for the href to be executed on click.
const handleClick = (event)=>{
    event.stopPropagation();
};
const renderIcon = (name)=>name ? /*#__PURE__*/ React.createElement("span", {
        className: "submenu__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: name
    })) : null
;
const SubMenuLinks = ({ items , ariaLabel , className , level =1 , handleKeyDown , tabIndex  })=>{
     return React.createElement("ul", {
        "aria-label": ariaLabel,
        className: classnames('submenu__items', `submenu__level-${level}`)
    }, items.map((item, index)=>{
        var ref6, ref1, ref2, ref3, ref4;
        if (!item.label) {
            return null;
        }
        let href = '';
        if (item.link && item.link.href) {
            href = item.link.href;
        }
        if (item.parameters && item.parameters.queryString && item.parameters.queryString.length) {
            href += item.parameters.queryString;
        }
        let action;
        if (item.parameters && item.parameters.action) {
            action = item.parameters.action;
            href = '';
        }
        const icon = (item === null || item === void 0 ? void 0 : (ref6 = item.parameters) === null || ref6 === void 0 ? void 0 : ref6.icon) || '';
        const classes = classnames('submenu__item', className, ((ref1 = item.link) === null || ref1 === void 0 ? void 0 : ref1.active) && 'submenu__item--active');
        const onClick = ((ref2 = item.link) === null || ref2 === void 0 ? void 0 : ref2.onClick) ? (e)=>{
            var ref, ref5;
            return (ref = item.link) === null || ref === void 0 ? void 0 : (ref5 = ref.onClick) === null || ref5 === void 0 ? void 0 : ref5.call(ref, e), handleClick(e);
        } : handleClick;
        return /*#__PURE__*/ React.createElement("li", {
            className: classes,
            key: `${item.label}-${index}`
        }, action && !href && /*#__PURE__*/ React.createElement("button", {
            className: "submenu__link",
            onClick: action,
            onKeyDown: handleKeyDown,
            tabIndex: tabIndex
        }, renderIcon(icon), item.label), href && !action && /*#__PURE__*/ React.createElement("a", {
            className: "submenu__link",
            onClick: onClick,
            href: href,
            "data-t": ((ref3 = item.parameters) === null || ref3 === void 0 ? void 0 : ref3.testId) ? `submenu-link-${item.parameters.testId}` : undefined,
            onKeyDown: handleKeyDown,
            tabIndex: tabIndex
        }, renderIcon(icon), item.label), !href && !action && /*#__PURE__*/ React.createElement("p", null, renderIcon(icon), item.label), ((ref4 = item.childMenuItems) === null || ref4 === void 0 ? void 0 : ref4.length) ? /*#__PURE__*/ React.createElement(SubMenuLinks, {
            items: item.childMenuItems,
            ariaLabel: item.label,
            level: 2,
            handleKeyDown: handleKeyDown,
            tabIndex: tabIndex
        }) : null);
    }));
};
/**
 * No opcos use this menu style on production anymore,
 * However it's still used on some test/acct environments.
 * We should update the content in BR on those environments before removing this.
 * @deprecated
 */ const getCategoryLinksItem = (item)=>{
    const link = item.link && item.link.href || '';
    const imageUrl = item.parameters && item.parameters.image || '';
    return {
        title: item.label,
        link: {
            url: link,
            target: 'internal'
        },
        image: {
            url: imageUrl,
            dimensions: {
                w: 200,
                h: 170
            }
        }
    };
};
const hasCategoryLinks = (menuItems)=>{
    const imageItems = menuItems.filter((item)=>item.parameters && item.parameters.image
    );
    return !!imageItems.length;
};
const SubMenu = ({ menuItems , isActive =false , closeSubMenu  })=>{
    const hasImages = hasCategoryLinks(menuItems);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            closeSubMenu();
        }
    };
    const tabIndex = isActive ? undefined : -1;
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": "site-nav-submenu",
        "aria-hidden": !isActive,
        className: classnames('submenu', {
            'submenu--with-image': hasImages,
            _is_active: isActive
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "submenu__content"
    }, menuItems.map((item)=>{
        var ref;
         return React.createElement("div", {
            className: "submenu__column",
            key: item.label
        }, item.parameters && item.parameters.image && /*#__PURE__*/ React.createElement(CategoryLinks, null, "[", /*#__PURE__*/ React.createElement(CategoryLinksItem, swcHelpers.extends({}, getCategoryLinksItem(item))), "]"), item.link && item.link.href ? /*#__PURE__*/ React.createElement("a", {
            className: "submenu__link",
            href: item.link.href,
            "data-t": "submenu-title-link",
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            tabIndex: tabIndex
        }, /*#__PURE__*/ React.createElement(Heading, {
            variant: "small",
            className: "submenu__title",
            component: "div",
            visualHeadingOnly: true
        }, item.label)) : /*#__PURE__*/ React.createElement(Heading, {
            variant: "small",
            className: "submenu__title",
            component: "div",
            visualHeadingOnly: true
        }, item.label), ((ref = item.childMenuItems) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ React.createElement(SubMenuLinks, {
            items: item.childMenuItems,
            ariaLabel: item.label,
            handleKeyDown: handleKeyDown,
            tabIndex: tabIndex
        }) : null);
    })));
};
var SubMenu$1 = SubMenu;

export { SubMenu, SubMenuLinks, SubMenu$1 as default };
//# sourceMappingURL=SubMenu.js.map
